import React from "react";
import { Search, Bell, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function TopBar({ title, onOpenPalette }) {
  const { user } = useAuth();

  return (
    <header
      data-testid="app-topbar"
      className="sticky top-0 z-30 bg-white border-b border-[var(--miro-border)]"
    >
      <div className="flex items-center gap-4 px-6 py-3">
        <div className="flex-1 min-w-0">
          <div className="miro-overline">MIRO One</div>
          <h1 className="font-display font-bold text-xl text-[var(--miro-navy)] leading-tight truncate">
            {title}
          </h1>
        </div>

        <button
          data-testid="global-search-btn"
          onClick={onOpenPalette}
          className="hidden md:flex items-center gap-2 bg-[var(--miro-bg)] border border-[var(--miro-border)] rounded-lg px-3 py-2 w-80 text-left hover:border-[var(--miro-blue)] transition-colors"
        >
          <Search size={16} className="text-[var(--miro-text-muted)]"/>
          <span className="text-sm flex-1 text-[var(--miro-text-muted)]">
            Search leads, contacts, tasks…
          </span>
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-white border border-[var(--miro-border)] text-[var(--miro-text-muted)] font-mono">⌘K</span>
        </button>

        <a
          href="/leadform"
          target="_blank"
          rel="noreferrer"
          data-testid="topbar-public-form-link"
          className="hidden lg:inline-flex items-center gap-1.5 text-xs font-semibold text-[var(--miro-blue-600)] hover:text-[var(--miro-blue)] transition-colors"
        >
          Public lead form <ExternalLink size={13}/>
        </a>

        <button
          data-testid="notifications-btn"
          className="relative w-9 h-9 rounded-lg border border-[var(--miro-border)] flex items-center justify-center text-[var(--miro-text-secondary)] hover:text-[var(--miro-navy)] hover:border-[var(--miro-blue)] transition-colors"
        >
          <Bell size={17}/>
          <span className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-[var(--miro-green)]"/>
        </button>

        <div className="flex items-center gap-2 pl-3 border-l border-[var(--miro-border)]">
          <div className="w-9 h-9 rounded-full bg-[var(--miro-navy)] text-white flex items-center justify-center font-display font-bold">
            {user?.name?.[0] || "M"}
          </div>
          <div className="hidden md:block leading-tight">
            <div className="text-sm font-semibold text-[var(--miro-navy)]">{user?.name}</div>
            <div className="text-[11px] text-[var(--miro-text-muted)] capitalize">{user?.role?.replace(/_/g," ")}</div>
          </div>
        </div>
      </div>
    </header>
  );
}
